module.exports = __webpack_public_path__ + "media/images/badges/yogasix/active/Y6Warrior2022_Badges_4250_Active@1x-3e723c310c655b0d4bab905d6e8d6dca.png";